export default () => {
  const top = document.querySelector('#plansSection').offsetTop - 90
  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top
  })
}
